import React from 'react';
import { Box, Typography } from '@mui/material';
import ButtonComp from '../../../ButtonComp/ButtonComp';

const LoginSelectButton = ({ icon: Icon, title, description, isSelected, onSelect , alert}) => {
  return (
    <Box sx={{position:'relative', display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor:isSelected ? '#ECF6FE':'white' , padding:'10px' , borderRadius:'8px'}}>
        <Box sx={{ borderRadius: '50%', backgroundColor: 'white' , marginRight:'10px'}}>
            <Icon sx={{ color: '#004878', fontSize: '50px' }} />
        </Box>
        <Box sx={{ width: '180px' }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, fontSize: '14px', textAlign: 'start' }}>{title}</Typography>
            <Typography variant="subtitle1" sx={{ fontWeight: 400, fontSize: '11px', textAlign: 'start' , lineHeight:1.3}}>{description}</Typography>
        </Box>
        <ButtonComp 
            text={isSelected ? 'Selected' : 'Select'} 
            onClick={onSelect}  
            className={`px-[20px] rounded-full ${isSelected ? 'bg-[#004878] text-[white]' :'border-[#004878] text-[#004878] '} border-1 py-[10px] leading-5 w-[110px]`} 
        />
        {alert && <div className='absolute bg-[#c00000] bottom-1 px-1 right-0'>
          <Typography variant='subtitle2' sx={{fontSize:'9px' , color:'white'}}>
            {alert}
          </Typography>
        </div>}
    </Box>
  )
}

export default LoginSelectButton